import "./blogs.css";
import Header from "components/header/header";
import Loading from "components/loading/loading";
import { blogs } from "./assets/blogs";
import starImage from "./assets/star.png";
import flowerImage from "./assets/red-flower.png";
import { useEffect, useState } from "react";
import * as blogService from "../../services/blog-service.js";

function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const fetchBlogs = async () => {
    setIsLoading(true);
    const blogs = await blogService.fetchBlogs();
    setBlogs(blogs.data);
    setIsLoading(false);
  };
  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <>
      <Header></Header>
      <div className="blogs-header interlude-text-color mudstone-sans">
        <div className="blogs-header-shader"></div>
        <div className="main-header">CHERRY CHORDS & CRISIS CHRONICLES</div>
        <img className="blog-star d-none d-md-block" alt="" src={starImage} />
        <img
          className="blog-flower d-none d-md-block"
          alt=""
          src={flowerImage}
        />
      </div>
      {!isLoading ? (
        <div className="blogs new-order">
          {blogs &&
            blogs.map((blog) => (
              <a className="blog mb-5 pt-2" href={"/blog/" + blog._id}>
                <h1 className="bold blog-title">{blog.title}</h1>
                <h4>{blog.date}</h4>
                <div className="blog-image">
                  <img alt="" src={"./assets/blog/" + blog.image} />{" "}
                </div>
                <h5 className="blog-text pt-4">
                  {blog.text.trim().split("\n")[0]}...
                </h5>
              </a>
            ))}
        </div>
      ) : (
        <Loading></Loading>
      )}
    </>
  );
}

export default Blogs;
